export default __webpack_public_path__ + "static/US-54a2c8c8685bbd195a18d166ccdba8aa.png";